// Form rules for a team, apart from the component that draws them.
// They mirror data/schemas/team.js and data/schemas/team_member.js.

export const NAME_MAX = 120;

export const STATUS_OPTIONS = [
    { value: 2, label: 'Activo' },
    { value: 1, label: 'Inactivo' },
];

// The six the backend accepts. The column is `team_role` — the design
// documents call it `role_in_team`, and the backend's own note says the column
// came first and the prose is what gets fixed (finding H10.2-a). The name that
// exists is the one used here.
//
// A ROLE IN A TEAM IS NOT A PERMISSION. `lead` grants nothing by itself: what
// somebody can do comes from users.role, and where they can do it comes from
// the team assignment. Mixing the two is how you end up with twenty roles.
export const TEAM_ROLE_OPTIONS = [
    { value: 'lead',   label: 'Lead' },
    { value: 'dev',    label: 'Dev' },
    { value: 'qa',     label: 'QA' },
    { value: 'design', label: 'Diseño' },
    { value: 'ops',    label: 'Ops' },
    { value: 'member', label: 'Miembro' },
];

export const EMPTY_VALUES = { name: '', description: '', status: 2 };

export function valuesFrom(team) {
    return {
        name: team?.name ?? '',
        description: team?.description ?? '',
        status: team?.status ?? 2,
    };
}

export function validate(values) {
    const errors = {};
    const name = values.name.trim();

    if (!name) errors.name = 'El nombre del equipo es requerido';
    else if (name.length > NAME_MAX) errors.name = `No puede pasar de ${NAME_MAX} caracteres`;

    return errors;
}

// Empty optional fields travel as null and not as '': the column is nullable,
// and an empty string says "somebody typed nothing", which is not "unknown".
export function toPayload(values) {
    return {
        name: values.name.trim(),
        description: values.description.trim() || null,
        status: Number(values.status),
    };
}
